// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import About from './sections/About';
import Work from './sections/Work';
import Contact from './sections/Contact';
import Videos from './sections/Videos';
import Welcome from './sections/Welcome';
import Blog from './sections/Blog';
import Formacao from './sections/Formacao';
import CorporateImpact from './sections/CorporateImpact';
import EbookHighlight from './sections/EbookHighlight';
import ThankYou from './sections/ThankYou';
import ContactSuccess from './sections/ContactSuccess';
import PrivacyPolicy from './sections/PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="bg-white text-chocolate font-cormorant overflow-x-hidden">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <main>
                <Welcome />
                <About />
                <Formacao />
                <CorporateImpact />
                <Work />
                <EbookHighlight />
                <Blog />
                <Videos />
                <Contact />
              </main>
            }
          />
          <Route path="/obrigado" element={<ThankYou />} />
          <Route path="/contato-enviado" element={<ContactSuccess />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
